var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", { staticClass: "ui celled striped table" }, [
    _c(
      "tbody",
      _vm._l(_vm.announcementForms, function (form, i) {
        return _c("tr", { key: i }, [
          _c("td", [
            _c(
              "form",
              { staticClass: "ui form", class: { warning: form.hasErrors() } },
              [
                _c(
                  "div",
                  { staticClass: "field", class: { required: !form.model.id } },
                  [
                    _c("label", [_vm._v("お知らせタイトル")]),
                    _vm._v(" "),
                    form.model.id
                      ? [_c("div", [_vm._v(_vm._s(form.model.title))])]
                      : [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: form.model.title,
                                expression: "form.model.title",
                              },
                            ],
                            attrs: { type: "text" },
                            domProps: { value: form.model.title },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  form.model,
                                  "title",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: { form: form, field: "title" },
                          }),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field", class: { required: !form.model.id } },
                  [
                    _c("label", [_vm._v("URL")]),
                    _vm._v(" "),
                    form.model.id
                      ? [
                          _c("a", { attrs: { href: form.model.url } }, [
                            _vm._v(_vm._s(form.model.url)),
                          ]),
                        ]
                      : [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: form.model.url,
                                expression: "form.model.url",
                              },
                            ],
                            attrs: { type: "text" },
                            domProps: { value: form.model.url },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(form.model, "url", $event.target.value)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("validation-message", {
                            attrs: { form: form, field: "url" },
                          }),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c("validation-message", {
                  attrs: { form: form, field: "template_max" },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "actions" }, [
            !form.model.id
              ? _c(
                  "button",
                  {
                    staticClass: "ui tiny positive button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.saveAnnouncementTemplate(form)
                      },
                    },
                  },
                  [_vm._v("保存")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ui tiny red button",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.deleteAnnouncementTemplate(form, i)
                  },
                },
              },
              [_vm._v("削除")]
            ),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.announcementForms.length < 10
      ? _c("tfoot", { staticClass: "full-width" }, [
          _c("th", { attrs: { colspan: "2" } }, [
            _c("div", { staticClass: "ui center aligned" }, [
              _c("i", {
                staticClass: "clickable plus green large icon",
                on: {
                  click: function ($event) {
                    return _vm.newAnnouncementTemplate()
                  },
                },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }